import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "12px 16px",
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7"
  },

  titleLeft: {
    display: "flex",
    alignItems: "baseline",
    gap: "10px",
    minWidth: 0
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  titleSerial: {
    fontSize: "13px",
    color: "#736973",
    fontFamily: "monospace"
  },

  titleRight: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexShrink: 0
  },

  badgeHealthy: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    padding: "3px 10px",
    borderRadius: "12px",
    backgroundColor: "rgba(63, 125, 63, 0.1)",
    color: "#3f7d3f"
  },

  badgeUnhealthy: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    padding: "3px 10px",
    borderRadius: "12px",
    backgroundColor: "rgba(211, 47, 47, 0.1)",
    color: "#d32f2f"
  },

  badgeIcon: {
    fontSize: "17px"
  },

  badgeText: {
    fontSize: "12px",
    fontWeight: 500,
    color: "inherit",
    whiteSpace: "nowrap"
  },

  dialogContent: {
    padding: "16px",
    // MUI zeroes padding-top on a DialogContent that follows a DialogTitle
    // (`.MuiDialogTitle-root + .MuiDialogContent-root`); that rule outranks a
    // single class, so restore it at matching specificity.
    "&.MuiDialogContent-root": {
      paddingTop: "16px"
    }
  },

  sectionTitle: {
    fontSize: "12px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "#8f8a8f",
    marginBottom: "10px"
  },


  overviewGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "12px"
  },

  overviewField: {
    minWidth: 0
  },

  fieldLabel: {
    fontSize: "11px",
    color: "#8f8a8f",
    marginBottom: "2px"
  },

  fieldValue: {
    fontSize: "14px",
    color: "#333",
    wordBreak: "break-word"
  },

  fieldValueProblem: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#d32f2f",
    wordBreak: "break-word"
  },

  divider: {
    margin: "18px 0"
  },

  countRow: {
    display: "flex",
    gap: "12px",
    flexWrap: "wrap"
  },

  countTile: {
    flex: "1 1 120px",
    padding: "12px",
    borderRadius: 4,
    border: "1px solid #e5e2e5",
    backgroundColor: "#fbfafb",
    textAlign: "center"
  },

  countValue: {
    fontSize: "22px",
    fontWeight: 500,
    color: "#4b1c46",
    lineHeight: 1.2
  },

  countLabel: {
    fontSize: "11px",
    color: "#8f8a8f",
    textTransform: "uppercase",
    letterSpacing: "0.4px"
  },

  noProblems: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "14px",
    borderRadius: 4,
    border: "1px solid rgba(63, 125, 63, 0.3)",
    backgroundColor: "rgba(63, 125, 63, 0.06)"
  },

  noProblemsIcon: {
    fontSize: "20px",
    color: "#3f7d3f"
  },

  noProblemsText: {
    fontSize: "13px",
    color: "#3f7d3f"
  },

  problemGroup: {
    marginBottom: "12px",
    borderRadius: 4,
    border: "1px solid rgba(211, 47, 47, 0.25)",
    overflow: "hidden"
  },

  problemHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "8px 12px",
    backgroundColor: "rgba(211, 47, 47, 0.07)"
  },

  problemLabel: {
    fontSize: "13px",
    fontWeight: 500,
    color: "#a32222"
  },

  problemCount: {
    fontSize: "12px",
    fontWeight: 500,
    color: "#fff",
    backgroundColor: "#d32f2f",
    borderRadius: "10px",
    minWidth: "22px",
    padding: "1px 7px",
    textAlign: "center"
  },

  unitList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
    padding: "10px 12px"
  },

  unitChip: {
    display: "flex",
    flexDirection: "column",
    padding: "4px 10px",
    borderRadius: 3,
    border: "1px solid #e5e2e5",
    backgroundColor: "#fbfafb"
  },

  unitName: {
    fontSize: "12px",
    color: "#333"
  },

  unitTimestamp: {
    fontSize: "11px",
    color: "#8f8a8f"
  }
}));

export default useStyles;
